module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Clients","newClient":"New Client","modal":{"newClientTitle":"New Client","clientDetailsTitle":"Client details","cancel":"Cancel"}},"hr":{"title":"Klijenti","newClient":"Novi klijent","modal":{"newClientTitle":"Novi klijent","clientDetailsTitle":"Detalji klijenta","cancel":"Odustani"}}}')
  delete Component.options._Ctor
}
